import React, { Suspense } from 'react';

const ChargerMap = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ChargerMap" */
      '@components/components/ChargerMap/ChargerMap'
    ),
);
const CmsChargerMap = ({ headingLevel, center }) => (
  <Suspense fallback={null}>
    <ChargerMap defaultCenter={center} headingLevel={headingLevel} />
  </Suspense>
);

export default CmsChargerMap;
